import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { ConfigurationSectionAssayGroupCreateRequest, ConfigurationSectionAssayGroupResponse } from '@/modules/configurationModule/detail/local-laboratory-module/sections/services/configuration-section-assay-group/configuration-section-assay-group.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class ConfigurationSectionAssayGroupService {
    async create(laboratoryId: number, request: ConfigurationSectionAssayGroupCreateRequest): Promise<ConfigurationSectionAssayGroupResponse> {
        const response = await axios.post<ConfigurationSectionAssayGroupResponse>(`/configuration/laboratories/${laboratoryId}/sectionAssayGroups`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationSectionAssayGroupResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationSectionAssayGroupResponse>>(`/configuration/laboratories/${laboratoryId}/sectionAssayGroups`, { ...filterModel }, { params })
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/sectionAssayGroups/batch`, { data: request })
        return response.data
    }
}

export const configurationSectionAssayGroupService = new ConfigurationSectionAssayGroupService()
